import React from 'react';
import { userRoles } from '../../constants/constants';
import { fields } from './personalInformationFieldsData';
import { scopeNoteJSX, fieldsJSX } from './personalInformationFieldsJSX';
import FormHeader from '../shared/FormHeader';

const getPersonalInformation = props => {
  const { user, hasWritePermission } = props;
  let filteredFields;

  switch (user.role) {
    case userRoles.val_technician:
      {
        const toIcludeFields = ['firstName', 'patientId'];
        filteredFields = fields.filter(field => toIcludeFields.includes(field.name));
      }
      break;
    default:
      filteredFields = fields;
  }

  const titleRow1 = "Prostate Core Needle Biopsy Histopathology Report"
  const titleRow2 = "Part 1 - Clinical Information/Specimen Receipt"
  return (
    <>
      <FormHeader titleRow1={titleRow1} titleRow2={titleRow2} />
      {fieldsJSX(filteredFields, hasWritePermission)}
      {scopeNoteJSX()}
    </>
  );
};

export default getPersonalInformation;
